import type { EnumUnion } from "@dresscode-frontend/utility-types";

import type {
  ApiResponseBody,
  ApiSearchQuery,
} from "@/lib/api/api-type-helper";

import type { PeopleAlumniTableRow } from "./-types";

export type FilterKey = Extract<
  keyof ApiResponseBody<"/v2/people/count", "get">,
  | "EMPLOYEE_ALUMNI"
  | "BOARD_ALUMNI"
  | "CONTRACTOR_ALUMNI"
  | "COLLABORATOR_ALUMNI"
  | "ALL_ALUMNI"
>;

export const FilterKey = {
  EMPLOYEE_ALUMNI: "EMPLOYEE_ALUMNI",
  BOARD_ALUMNI: "BOARD_ALUMNI",
  CONTRACTOR_ALUMNI: "CONTRACTOR_ALUMNI",
  COLLABORATOR_ALUMNI: "COLLABORATOR_ALUMNI",
  ALL_ALUMNI: "ALL_ALUMNI",
} as const satisfies Record<FilterKey, FilterKey>;

export const TabKey = {
  EMPLOYEE: "Employee",
  BOARD: "Board",
  CONTRACTOR: "Contractor",
  COLLABORATOR: "Collaborator",
  ALL: "All",
} as const;

export type TabKey = EnumUnion<typeof TabKey>;

export const Columns = {
  LEAVING_DATE: "leavingDate",
  PERSON: "person",
  PERSONAL_CONTACT: "personalContact",
  LAST_WORKER_TYPE: "lastWorkerType",
  LAST_JOB_TYPES: "lastJobTypes",
  LAST_DEPARTMENT_AND_POSITION: "lastDepartmentAndPositions",
  LAST_PLACES: "lastPlaces",
  JOINING_DATE: "joiningDate",
  CONTRACT_START_DATE: "contractStartDate",
  STARTING_DATE: "startingDate",
  CURRENT_DEVICES: "currentDevices",
  CURRENT_APPS: "currentApps",
} as const satisfies Record<string, keyof PeopleAlumniTableRow>;

type QUERY = ApiSearchQuery<"/v2/people/count", "get">;
type ORDER_BY = Exclude<QUERY, undefined>["orderBy"];
export type ORDER_BY_FILTER = Exclude<
  ORDER_BY,
  "CONTRACT_DATE_TO" | "CONTRACT_DATE_FROM" | undefined
>;

export const SortColumns = [
  "PERSON_NAME",
  "JOB_TYPE",
  "WORKER_TYPE",
  "PLACE",
  "JOINED_ON",
  "LEFT_ON",
] as const satisfies ORDER_BY_FILTER[];

export type SORTABLE_COLUMNS = Extract<
  keyof PeopleAlumniTableRow,
  | "leavingDate"
  | "person"
  | "lastWorkerType"
  | "lastJobTypes"
  | "lastPlaces"
  | "joiningDate"
>;

export const ColumnsToSortColumns = {
  leavingDate: "LEFT_ON",
  person: "PERSON_NAME",
  lastWorkerType: "WORKER_TYPE",
  lastJobTypes: "JOB_TYPE",
  lastPlaces: "PLACE",
  joiningDate: "JOINED_ON",
} as const satisfies Record<SORTABLE_COLUMNS, ORDER_BY_FILTER>;

export const SortColumnsToColumns = {
  LEFT_ON: "leavingDate",
  PERSON_NAME: "person",
  WORKER_TYPE: "lastWorkerType",
  JOB_TYPE: "lastJobTypes",
  PLACE: "lastPlaces",
  JOINED_ON: "joiningDate",
} as const satisfies Record<ORDER_BY_FILTER, SORTABLE_COLUMNS>;
